export var FETCH_PROMOCODE_ACTIVATE = 'FETCH_PROMOCODE_ACTIVATE';
export var SUCCESS_FETCH_PROMOCODE_ACTIVATE = 'SUCCESS_FETCH_PROMOCODE_ACTIVATE';
export var FAILURE_FETCH_PROMOCODE_ACTIVATE = 'FAILURE_FETCH_PROMOCODE_ACTIVATE';



// WEBPACK FOOTER //
// ./src/actions/promoCode/promocodeAction.js